import { render } from "./GeneralButton.vue?vue&type=template&id=e624fed6&scoped=true"
import script from "./GeneralButton.vue?vue&type=script&lang=js"
export * from "./GeneralButton.vue?vue&type=script&lang=js"

import "./GeneralButton.vue?vue&type=style&index=0&id=e624fed6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e624fed6"]])

export default __exports__